import React from 'react';

import Header from 'Root/Main/Header';


export default function AccessDeniedPage() {
  return (
    <div>
      <Header />
      <div className="segment-bg-gray">
        <p>Недостаточно прав для просмотра страницы.</p>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/shared/components/AccessDeniedPage.js